import Vue from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
const options = {
    timeout: 5000,
    transition: 'fade',
    transitionDuration: {
        enter: 200,
        leave: 700,
    },
};
Vue.use(Toast, options);
